module.exports = __webpack_public_path__ + "media/icons/salonowy-unactive@3x-9b9bc04d.svg";